<template>
	<section class="member-notifications">
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<span>消息通知</span>
				<el-switch
					v-model="mute"
					active-text="邮件提醒"
					inactive-text="仅站内信"
					style="float: right"
					size="mini"
				/>
			</div>
			<el-timeline>
				<el-timeline-item
					v-for="message in notifications"
					:key="message.id"
					:type="message.type"
					:timestamp="message.time"
				>
					<div class="notification-title">
						{{ message.title }}
						<el-tag
							v-if="message.business"
							size="mini"
							effect="plain"
							type="info"
							style="margin-left: 8px"
						>
							{{ message.business }}
						</el-tag>
					</div>
					<div class="notification-desc">
						{{ message.desc }}
					</div>
				</el-timeline-item>
			</el-timeline>
		</el-card>
	</section>
</template>

<script>
export default {
	name: 'MemberNotifications',
	props: {
		notifications: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			mute: false
		}
	}
}
</script>

<style lang="scss" scoped>
.notification-title {
	font-weight: 600;
	color: #303133;
}

.notification-desc {
	font-size: 13px;
	color: #606266;
	margin-top: 4px;
}
</style>

